@if (initialized && dto) {

    @if (uiMode == 'side') {
        <cm-partner-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cm-partner-side>

    } @else {
        <cm-partner-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
        ></cm-partner-full>
    }
}